export default __webpack_public_path__ + "static/media/e-commerce.13f7636a.png";